import * as Sentry from '@sentry/react'
import { GET_USER_QUERY } from '../queries/user'
import { GetUserQuery } from '../lib/apollo/operations'
import { authState } from '../store/state'
import { createApolloClient } from '../configuration/apollo'
import { overmindInstance } from '../store'

export const onLogin = async () => {
  const client = createApolloClient()

  const {
    data: {
      Me: { id, fullName, email }
    }
  } = await client.query<GetUserQuery>({ query: GET_USER_QUERY })

  Sentry.setUser({ email, id, username: fullName })

  overmindInstance.actions.setAuthState(authState.loggedIn)
}

export const onLogout = async () => {
  Sentry.configureScope(scope => scope.setUser(null))

  overmindInstance.actions.setAuthState(authState.loggedOut)
}
